"use strict";
// Unified Moderation Types
// Provides type-safe discriminated unions for all moderation item types
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModerationQueueCategory = exports.ModerationScanResult = exports.ModerationResolution = void 0;
exports.isPatternModeration = isPatternModeration;
exports.isReviewModeration = isReviewModeration;
exports.isMaterialContribution = isMaterialContribution;
exports.isCommentModeration = isCommentModeration;
exports.isCraftRoomModeration = isCraftRoomModeration;
exports.isProfileModeration = isProfileModeration;
// Re-export enums as canonical types
const moderation_status_1 = require("../enums/moderation-status");
Object.defineProperty(exports, "ModerationResolution", { enumerable: true, get: function () { return moderation_status_1.ModerationResolution; } });
const scan_result_1 = require("../enums/scan-result");
Object.defineProperty(exports, "ModerationScanResult", { enumerable: true, get: function () { return scan_result_1.DatabaseScanResult; } });
// ===== TYPE GUARDS =====
function isPatternModeration(item) {
    return item.type === 'pattern';
}
function isReviewModeration(item) {
    return item.type === 'review';
}
function isMaterialContribution(item) {
    return item.type === 'material';
}
function isCommentModeration(item) {
    return item.type === 'comment';
}
function isCraftRoomModeration(item) {
    return item.type === 'craft_room';
}
function isProfileModeration(item) {
    return item.type === 'profile';
}
// ===== QUERY OPTIONS =====
// Re-export enum as canonical type
const entity_type_1 = require("../enums/entity-type");
Object.defineProperty(exports, "ModerationQueueCategory", { enumerable: true, get: function () { return entity_type_1.ModerationQueueCategory; } });
